import { combineReducers } from 'redux';
import authReducer from './auth';
import galleryReducer from './gallery';
import allMultitourStatsReducer from './allMultitourStats';
import datePickerReducer from './datePicker';
import tooltipDurationReducers from './durationTooltip';
import visitsTooltip from './visitsTooltip';
import pointsVisitsTooltip from './pointsVisitsTooltip';
import timeStep from './timeStep';
import companyStatsReducer from './companyStats';

export default combineReducers({
  auth: authReducer,
  gallery: galleryReducer,
  allMultitourStats: allMultitourStatsReducer,
  datePicker: datePickerReducer,
  durationTooltip: tooltipDurationReducers,
  companyStats: companyStatsReducer,
  visitsTooltip,
  pointsVisitsTooltip,
  timeStep,
});
